export const colors = {
  white: '#fff',
  bgWhite: '#f5f5f5',
  veryLightPink: '#dedede',
  reddishPink: '#ff294e',
  black: '#181818',
  secondaryBlack: '#2b2b2b',
}
